export const ADS_ROOT = "/ads";
export const ADS_DRAGGABLE = ADS_ROOT + "/sortDraggable";